export default "__VITE_ASSET__B5ZwK0Bw__"